import React from "react";
import Typography from "@mui/material/Typography";
import styles from "./SectionTitle.module.scss";
import cx from "classnames";

const SectionTitle = (props) => {
	const containerClass = cx(styles.titleContainer, {
		[styles["titleContainer--bottomMarged"]]: props.bottomMarged,
		[styles["titleContainer--topMarged"]]: props.topMarged,
	});

	return (
		<div className={containerClass}>
			<Typography variant="h6" className={styles.title} component="div">
				{props.title}
			</Typography>
			<Typography variant="h6" className={styles.subtitle} component="div">
				{props.subtitle}
			</Typography>
		</div>
	);
};

export default SectionTitle;
